export default "__VITE_ASSET__BT1Wi8tY__"